import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { installClientErrorReporter } from "@/lib/monitoring/clientErrorReporter";
import { installLeafletGuard } from "@/lib/monitoring/leafletGuard";

// Install global error sink as early as possible so we capture
// boot-time issues (chunk load failures, provider crashes).
installClientErrorReporter();
// Wrap Leaflet's LatLng so NaN/Infinity coordinates produce a rich
// diagnostic report (args + stack + current screen/filter context).
installLeafletGuard();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
